import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * twMerge only resolves conflicts between classes it recognises, and it recognises Tailwind's
 * default scales. Every theme key in `globals.css` whose suffix is not a t-shirt size must be
 * registered here, or a caller's `rounded-lg` and a component's `rounded-tile` both survive and
 * stylesheet order — not the call site — picks the winner.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display', 'display-sm'],
      radius: ['tile'],
      shadow: ['tremor-card', 'tremor-dropdown', 'menu'],
      animate: ['fade-in', 'auth-float', 'auth-pulse', 'pulse-glow', 'word-cycle'],
    },
    classGroups: {
      z: [{ z: ['panel-resizer', 'table-bar', 'sidebar', 'dialog', 'dropdown', 'tooltip'] }],
    },
  },
});

function classNames(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export default classNames;
